import React, { useEffect,useState,useRef } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import Recommended from "@/components/Pages/Finance/PageSimpleEarn/Recommended";
import AllProducts from "@/components/Pages/Finance/PageSimpleEarn/AllProducts";
// import DurationSelect from "../DurationSelect";

export default observer(() => {
  const t = useTranslation();
  const { finance } = useStore();

  return (
    <div className={styles.main}>
      <Recommended/>
      <AllProducts/>
    </div>
  );
});